<div class="main-content brand-storefronts-page">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-header-{{ color }}-1">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div class="d-flex align-items-center">
            <i class="material-icons pointer mr-2" (click)="back()">arrow_back</i>
            <div>
              <h4 class="card-title mb-0">Brand Storefronts</h4>
              <p class="card-category mb-0">Enable branded menu links and manage monthly billing</p>
            </div>
          </div>
          <button type="button" class="btn btn-outline-light btn-sm" (click)="runBilling()" [disabled]="billing">
            {{ billing ? 'Running…' : 'Run due billing' }}
          </button>
        </div>
      </div>

      <div class="card-body">
        <div *ngIf="message" class="alert" [ngClass]="messageType === 'success' ? 'alert-success' : 'alert-danger'">{{ message }}</div>

        <div class="row">
          <div class="col-lg-5">
            <div class="d-flex align-items-center mb-2">
              <input type="search" class="form-control mr-2" placeholder="Search brands…"
                     [value]="search" (input)="onSearchChange($any($event.target).value)"
                     [disabled]="reorder">
              <button type="button" class="btn btn-sm text-nowrap"
                      [ngClass]="reorder ? 'btn-secondary' : 'btn-outline-secondary'"
                      (click)="toggleReorder()">
                {{ reorder ? 'Done' : 'Reorder' }}
              </button>
            </div>

            <div *ngIf="reorder" class="alert alert-info py-2 px-3 small mb-2">
              Drag brands into the order buyers see them on the brand wall and the home page.
              <button type="button" class="btn btn-primary btn-sm ml-2"
                      (click)="saveOrder()" [disabled]="saving || !reorderDirty">
                {{ saving ? 'Saving…' : 'Save order' }}
              </button>
            </div>
            <div class="table-responsive brand-storefronts-table-wrap">
              <table class="table table-hover table-sm mb-0">
                <thead>
                  <tr>
                    <th>Brand</th>
                    <th>Status</th>
                    <th>Fee</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!reorder">
                  <tr *ngFor="let row of filteredRows; let i = index"
                      (click)="!reorder && selectRow(row)"
                      [class.table-active]="selected?.manufacturer_id === row.manufacturer_id"
                      class="brand-row" [class.is-reordering]="reorder"
                      cdkDrag [cdkDragDisabled]="!reorder">
                    <td>
                      <span *ngIf="reorder" class="drag-handle mr-2" cdkDragHandle title="Drag to reorder">⋮⋮</span>
                      <span *ngIf="reorder" class="badge badge-dark mr-2">{{ i + 1 }}</span>
                      <strong>{{ row.brand_name }}</strong>
                      <div class="small text-muted">{{ row.slug || '—' }}</div>
                    </td>
                    <td><span class="badge" [ngClass]="statusClass(row)">{{ statusLabel(row) }}</span></td>
                    <td>{{ row.monthly_fee | number:'1.0-0' }}/mo</td>
                    <td>
                      <button type="button" class="btn btn-link btn-sm p-0" (click)="copyLink(row); $event.stopPropagation()" [disabled]="!row.share_url">Copy</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="loading" class="p-3 mb-0 text-muted">Loading brands…</p>
              <p *ngIf="!loading && !filteredRows.length" class="p-3 mb-0 text-muted">No brands match your search.</p>
            </div>
            <p *ngIf="copyHint" class="small text-success mt-2 mb-0">{{ copyHint }}</p>
          </div>

          <div class="col-lg-7">
            <div *ngIf="!selected" class="brand-storefronts-empty">
              <i class="material-icons">storefront</i>
              <p>Select a brand to configure its storefront subscription and menu link.</p>
            </div>

            <form *ngIf="selected" [formGroup]="form" (ngSubmit)="save()" class="brand-storefronts-detail">
              <div class="detail-header">
                <div>
                  <h3>{{ selected.brand_name }}</h3>
                  <p *ngIf="selected.share_url" class="mb-0">
                    <a [href]="selected.share_url" target="_blank">{{ selected.share_url }}</a>
                  </p>
                </div>
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="copyLink(selected)" [disabled]="!selected.share_url">Copy menu link</button>
              </div>

              <div *ngIf="selected.analytics" class="analytics-grid mb-4">
                <div class="analytics-card">
                  <span class="analytics-card__label">Visits</span>
                  <span class="analytics-card__value">{{ selected.analytics.unique_sessions || 0 }}</span>
                </div>
                <div class="analytics-card">
                  <span class="analytics-card__label">Page views</span>
                  <span class="analytics-card__value">{{ selected.analytics.page_views || 0 }}</span>
                </div>
                <div class="analytics-card">
                  <span class="analytics-card__label">Orders</span>
                  <span class="analytics-card__value">{{ selected.analytics.orders || 0 }}</span>
                </div>
                <div class="analytics-card">
                  <span class="analytics-card__label">Conversion</span>
                  <span class="analytics-card__value">{{ selected.analytics.conversion_rate || 0 }}%</span>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-4">
                  <label>Enabled</label>
                  <select class="form-control" formControlName="enabled">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label>Status</label>
                  <select class="form-control" formControlName="status">
                    <option value="active">Active</option>
                    <option value="paused">Paused</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label>Monthly fee ($)</label>
                  <input type="number" class="form-control" formControlName="monthly_fee" min="0" step="1">
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-4">
                  <label>Setup fee ($)</label>
                  <input type="number" class="form-control" formControlName="setup_fee" min="0" step="1">
                </div>
                <div class="form-group col-md-4">
                  <label>Bill-to debtor</label>
                  <input type="text" class="form-control" formControlName="bill_to_debtorno" placeholder="Required when active">
                </div>
                <div class="form-group col-md-4">
                  <label>Branch</label>
                  <input type="text" class="form-control" formControlName="bill_to_branchcode">
                </div>
              </div>

              <div class="form-group">
                <label>URL slug</label>
                <div class="input-group">
                  <div class="input-group-prepend"><span class="input-group-text">/brand/</span></div>
                  <input type="text" class="form-control" formControlName="slug" placeholder="cycling-frog">
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6">
                  <label>Order notification email</label>
                  <input type="email" class="form-control" formControlName="contact_email"
                         placeholder="orders@brand.com"
                         [class.is-invalid]="form.get('contact_email')?.invalid && form.get('contact_email')?.touched">
                  <small class="form-text text-muted">Where new-order alerts for this brand are sent. Blank turns them off.</small>
                  <div class="invalid-feedback">Not a valid email address.</div>
                </div>
                <div class="form-group col-md-6">
                  <label>Brand website</label>
                  <input type="text" class="form-control" formControlName="website_url" placeholder="brand.com/about">
                  <small class="form-text text-muted">Linked from the brand page. https:// is added if you leave it off.</small>
                </div>
              </div>

              <div class="form-group">
                <label>Welcome message</label>
                <textarea class="form-control" rows="2" formControlName="welcome_text" placeholder="Shown at the top of the branded menu"></textarea>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Hero banner image</label>
                  <input class="form-control" formControlName="hero_image" placeholder="URL or catalog/brands/hero.jpg">
                </div>
                <div class="form-group col-md-6">
                  <label>Secondary banner</label>
                  <input class="form-control" formControlName="banner_image">
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Promo banner</label>
                  <input class="form-control" formControlName="promo_banner_text" placeholder="Optional promotion text">
                </div>
                <div class="form-group col-md-6">
                  <label>Promo link</label>
                  <input class="form-control" formControlName="promo_banner_link" placeholder="https://…">
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-4">
                  <label>Accent color</label>
                  <input class="form-control" formControlName="accent_color" placeholder="#30121d">
                </div>
                <div class="form-group col-md-8">
                  <label>Internal notes</label>
                  <input class="form-control" formControlName="notes">
                </div>
              </div>

              <div class="form-check mb-3">
                <input type="checkbox" class="form-check-input" id="invoiceSetup" formControlName="invoice_setup_fee">
                <label class="form-check-label" for="invoiceSetup">Invoice setup fee on save (when applicable)</label>
              </div>

              <button type="submit" class="btn btn-primary" [disabled]="saving">{{ saving ? 'Saving…' : 'Save storefront' }}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
